import z from "zod";

import { dateSchema } from "./utils";

const announcementSchema = z.object({
  id: z.string(),
  title: z.string().catch(""),
  text: z.string().catch(""),
  cta: z.string().catch(""),
  url: z.string().catch(""),
  expires_at: dateSchema,
  disclaimer: z.string().optional().catch(undefined),
  thumbnail: z.string().optional().catch(undefined),
  thumbnail_shape: z.enum(["circle", "square"]).optional().catch(undefined),
  thumbnail_static: z.string().optional().catch(undefined),
  seen: z.boolean().catch(false),
});

type Announcement = z.infer<typeof announcementSchema>;

export { announcementSchema, type Announcement };
